import React from 'react';

import {
  minValue,
  required,
  SelectInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import NumberInput from '../../layout/inputFields/NumberInput';
import Label from '../../../customFields/Label';
import BooleanRadioGroupInput from '../../../customFields/BooleanRadioGroupInput';

import { shortTimePeriodChoices } from '../../../constants/timePeriods';

const MultipleIpCountries = () => (
  <Grid size={12}>
    <Grid container gap={1}>
      <Grid size={12}>
        <Label
          variant="label"
          title="Lookback period"
          info="The window in which IPs from two or more countries trigger the rule."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberInput
          source="ruleParameters.lookbackPeriod.amount"
          fullWidth
          label="Length"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectInput
          source="ruleParameters.lookbackPeriod.unit"
          choices={shortTimePeriodChoices}
          fullWidth
          label="Unit"
          validate={[required()]}
        />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="Include anonymous IPs"
          info="Whether IPs flagged as anonymous, such as VPNs, proxies or Tor, count towards the countries."
        />
      </Grid>
      <Grid size={12}>
        <BooleanRadioGroupInput
          source="ruleParameters.includeAnonymousIps"
          helperText={false}
          label={false}
          validate={required()}
          fullWidth
        />
      </Grid>
    </Grid>
  </Grid>
);

export default MultipleIpCountries;
